import { TablePaginationOptions } from '../tables/tables.types';

export const TAX_ACCOUNTING_TAX_TYPES = ['TVA', 'TVM'] as const;
export const TAX_ACCOUNTING_AMOUNT_TYPES = ['HT', 'TAXE'] as const;
export const TAX_ACCOUNTING_AMOUNT_SUB_TYPES = [
  'accessory',
  'battery',
  'battery_order',
  'charger',
  'consumable',
  'device',
  'hard_drive',
  'keyboard',
  'mouse',
  'ram',
  'shipping_fees',
  'warranty'
] as const;

export interface TaxAccountingEntry {
  id: number;
  country_code: string;
  tax_type: string;
  amount_type: string;
  amount_sub_type: string | null;
  accounting_account: string;
  created_at?: string;
  updated_at?: string;
}

export interface TaxAccountingEntryPayload {
  country_code: string;
  tax_type: string;
  amount_type: string;
  amount_sub_type?: string | null;
  accounting_account: string;
}

export interface TaxAccountingEntriesListOptions {
  filters?: Partial<Record<keyof TaxAccountingEntry, string | string[]>> & { fulltext?: string };
  pagination?: TablePaginationOptions;
}
